var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { staticClass: "box" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("PriorityList", {
              attrs: {
                planned: _vm.plannedFiltered,
                oldThreshold: _vm.oldThreshold,
                newThreshold: _vm.newThreshold
              },
              on: { update: _vm.updateData }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column-right" },
              [
                _c("WorkList", {
                  attrs: {
                    progressSorted: _vm.progressSorted,
                    oldThreshold: _vm.oldThreshold,
                    newThreshold: _vm.newThreshold
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "spacer" })
              ],
              1
            )
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcc8ec6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc8ec6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Work.vue
// module id = null
// module chunks = 